<div class="mb-4 rounded-2xl p-4">
  <app-partially-delivered-reasons-edit-component></app-partially-delivered-reasons-edit-component>
</div>